export default {
  src: 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js',
  autoBlockSrc:
    'https://cdn.cookielaw.org/consent/3a3222ac-f26c-4295-b561-671d5ea494b5-test/OtAutoBlock.js',
  domainScript: '3a3222ac-f26c-4295-b561-671d5ea494b5-test',
};
